var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { NOOP_QUERY } from "../constants";
import { kebabCase } from "lodash";
import { useAuth } from "./use-auth";
import { useEntityTypePageQueries } from "./use-entity-type-page-queries";
export var useEntityTypePageQuery = function (entityTypeName, slug) {
  var queries = useEntityTypePageQueries();
  var isAuthenticated = useAuth().isAuthenticated;
  var typeSlug = kebabCase(entityTypeName);
  var pageQuery = queries[entityTypeName];
  // have to turn off the cache for now, as data is being mixed up between view and slices... argh.
  // if there is no query, use cache-only to send a noop query - we don't want to actually send these to the server
  var fetchPolicy = pageQuery ? 'cache-first' : 'cache-only';
  // const { person, isLoading } = useActivePerson();
  var _a = __read(useLazyQuery(gql(pageQuery || NOOP_QUERY), {
      fetchPolicy: fetchPolicy,
      variables: {
        slug: slug
      }
    }), 2),
    fetch = _a[0],
    _b = _a[1],
    refetch = _b.refetch,
    data = _b.data,
    loading = _b.loading,
    error = _b.error;
  React.useEffect(function () {
    // if (!isLoading && person) {
    if (isAuthenticated) {
      fetch();
    }
  }, [isAuthenticated]);
  var entity = data === null || data === void 0 ? void 0 : data["".concat(typeSlug, "BySlug")];
  return {
    data: data,
    refetch: refetch,
    loading: loading || !data,
    entity: entity,
    error: error
  };
};